<template>
  <v-card tile flat class="text-md-start text-center">
    <div class="body-heading-large">Your Order</div>
    <v-list-item class="px-0">
      <v-list-item-content>
        <v-list-item-title class="body-heading-small">
          Single Purchase:
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ `${pointsAmount} points` }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="isAutoReload" class="px-0">
      <v-list-item-content>
        <v-list-item-title class="body-heading-small">
          Auto-Reload:
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ `${this.pointsAmount} points when points balance is below ${this.autoReloadPointsAmount}` }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item class="px-0" v-if="paymentMethod.card">
      <v-list-item-content>
        <v-list-item-title class="body-heading-small">
          Payment Method Details:
        </v-list-item-title>
        <v-list-item-subtitle>
          <PaymentCardField :card="paymentMethod.card" class="mx-0" />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item class="px-0">
      <v-list-item-content>
        <v-list-item-title class="body-heading-small">
          Billing Details
        </v-list-item-title>
        <v-list-item-subtitle>{{ user.name }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="paymentMethod.billing_details.email">{{ paymentMethod.billing_details.email }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="paymentMethod.billing_details.address.line1">{{ paymentMethod.billing_details.address.line1 }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="paymentMethod.billing_details.address.city && paymentMethod.billing_details.address.postal_code">{{ `${paymentMethod.billing_details.address.city}, ${paymentMethod.billing_details.address.postal_code}` }}</v-list-item-subtitle>
        <v-list-item-subtitle v-if="paymentMethod.country">{{ paymentMethod.billing_details.address.country }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
  import PaymentCardField from "@/components/Payment/PaymentCardField";

  export default {
    name: "OrderSummaryList",
    props: {
      pointsAmount: {
        type: Number,
        required: true,
      },
      isAutoReload: {
        type: Boolean,
      },
      autoReloadPointsAmount: {
        type: Number,
      },
      paymentMethod: {
        type: Object,
        required: true,
      },
    },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
    components: { PaymentCardField },
  };
</script>



// WEBPACK FOOTER //
// src/components/Points/Purchase/OrderSummaryList.vue